import { getLogin, setLogin, removeLogin } from '@/utils/auth'
import { commonRequest } from '@/utils/request'

const state = {
  isLogin: getLogin(),
  name: '',
  roles: null,
  infos: {},
  userid: null,
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_INFOS: (state, infos) => {
    state.infos = infos
  },
  SET_USERID: (state, userid) => {
    state.userid = userid
  },
  SET_COMPANY: (state, company) => {
    state.company = company
  }
}

const actions = {
  create: ({ commit }, data) => commonRequest({ data, url: '/user/create' }),
  update: ({ commit }, data) => commonRequest({ data, url: '/user/update' }),
  remove: ({ commit }, data) => commonRequest({ data, url: '/user/remove' }),
  list: ({ commit }, data) => commonRequest({ data, url: '/user/list' }),
  status: ({ commit }, data) => commonRequest({ data, url: '/user/status' }),
  select: ({ commit }, data) => commonRequest({ data, method: "get", url: '/user/select' }),
  updatepwd: ({ commit }, data) => commonRequest({ data, url: '/user/updatepwd' }),
  resetpwd: ({ commit }, data) => commonRequest({ data, url: '/user/resetpwd' }),
  update_email: ({ commit }, data) => commonRequest({ data, url: '/user/update_email' }),
  login({ commit }, data) {
    return new Promise((resolve, reject) => {
      commonRequest({ method: 'post', url: '/user/login', data }).then(res => {
        setLogin()
        resolve()
      }).catch((error) => reject(error))
    })
  },
  auth({ commit }, data) {
    return new Promise((resolve, reject) => {
      commonRequest({ url: '/user/auth', data }).then(response => {
        setLogin()
        resolve()
      }).catch(error => reject(error))
    })
  },
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      commonRequest({ method: 'get', url: '/user/me' }).then(res => {
        const { role, username } = res
        if (!role) reject('获取用户组失败')
        commit('SET_INFOS', res)
        commit('SET_ROLES', role.name)
        commit('SET_NAME', username)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      setLogin()
      resolve()
      commonRequest({ method: 'get', url: '/user/logout' }).catch(error => reject(error))
    })
  },
  signup({ commit, state }, data) { return commonRequest({ url: '/user/signup', data }) },


}

export default {
  namespaced: true,
  actions,
  mutations,
  state
}
